import { MoveStruct } from "../utils/index.mjs";
import { Bag } from "./bag.mjs";
import { bcs } from "@safecoin/safe/bcs";
//#region src/contracts/0x2/kiosk_extension.ts
/**************************************************************
* THIS FILE IS GENERATED AND SHOULD NOT BE MANUALLY MODIFIED *
**************************************************************/
const $moduleName = "0x2::kiosk_extension";
const Extension = new MoveStruct({
	name: `${$moduleName}::Extension`,
	fields: {
		storage: Bag,
		permissions: bcs.u128(),
		is_enabled: bcs.bool()
	}
});
const ExtensionKey = new MoveStruct({
	name: `${$moduleName}::ExtensionKey<phantom T0>`,
	fields: { dummy_field: bcs.bool() }
});
//#endregion
export { Extension, ExtensionKey };

//# sourceMappingURL=kiosk_extension.mjs.map